import { PutProcessStatusApi } from "@/features/accounts/ocr/services/put-process-status-api";
import { PutProcessStatusRequestModel } from "@/features/accounts/ocr/services/put-process-status-model";

/// OCR読み取り結果処理
export class PutProcessStatusService {
  private putProcessStatusApi = new PutProcessStatusApi();
  /**
   * OCR読み取り状況更新API実行
   */
  public async PutProcessStatus(param: PutProcessStatusRequestModel) {
    return await this.putProcessStatusApi.PutProcessStatus(param);
  }
}
